<template>
<div class="auth-box-w">
    <div class="logo-w"></div>
    <h4 class="auth-header">Login</h4>
    <form action="">
        <div class="form-group"><label for="">Username</label><input v-model="email" class="form-control" placeholder="Enter your username"
                type="text" autocomplete="off" style="background-image: url(&quot;data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAASCAYAAABSO15qAAAAAXNSR0IArs4c6QAAAPhJREFUOBHlU70KgzAQPlMhEvoQTg6OPoOjT+JWOnRqkUKHgqWP4OQbOPokTk6OTkVULNSLVc62oJmbIdzd95NcuGjX2/3YVI/Ts+t0WLE2ut5xsQ0O+90F6UxFjAI8qNcEGONia08e6MNONYwCS7EQAizLmtGUDEzTBNd1fxsYhjEBnHPQNG3KKTYV34F8ec/zwHEciOMYyrIE3/ehKAqIoggo9inGXKmFXwbyBkmSQJqmUNe15IRhCG3byphitm1/eUzDM4qR0TTNjEixGdAnSi3keS5vSk2UDKqqgizLqB4YzvassiKhGtZ/jDMtLOnHz7TE+yf8BaDZXA509yeBAAAAAElFTkSuQmCC&quot;); background-repeat: no-repeat; background-attachment: scroll; background-size: 16px 18px; background-position: 98% 50%;">
            <div class="pre-icon os-icon os-icon-user-male-circle"></div>
        </div>
        <div class="form-group"><label for="">Password</label><input v-model="password" class="form-control" placeholder="Enter your password"
                type="password" autocomplete="off" style="background-image: url(&quot;data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAASCAYAAABSO15qAAAAAXNSR0IArs4c6QAAAPhJREFUOBHlU70KgzAQPlMhEvoQTg6OPoOjT+JWOnRqkUKHgqWP4OQbOPokTk6OTkVULNSLVc62oJmbIdzd95NcuGjX2/3YVI/Ts+t0WLE2ut5xsQ0O+90F6UxFjAI8qNcEGONia08e6MNONYwCS7EQAizLmtGUDEzTBNd1fxsYhjEBnHPQNG3KKTYV34F8ec/zwHEciOMYyrIE3/ehKAqIoggo9inGXKmFXwbyBkmSQJqmUNe15IRhCG3byphitm1/eUzDM4qR0TTNjEixGdAnSi3keS5vSk2UDKqqgizLqB4YzvassiKhGtZ/jDMtLOnHz7TE+yf8BaDZXA509yeBAAAAAElFTkSuQmCC&quot;); background-repeat: no-repeat; background-attachment: scroll; background-size: 16px 18px; background-position: 98% 50%;">
            <div class="pre-icon os-icon os-icon-fingerprint"></div>
        </div>
        <div class="buttons-w"><button class="btn btn-primary" v-on:click.prevent="login">Login</button>
        <!--
            <div class="form-check-inline"><label class="form-check-label"><input class="form-check-input" type="checkbox">Remember
                    Me</label></div>
        -->
        </div>
    </form>
</div>
</template>
<style>
.auth-box-w .logo-w {
    text-align: center;
    padding: 15%;
}
.auth-box-w {
    max-width: 450px;
    margin: 0px auto;
    background-color: initial;
    border-radius: 6px;
    /* -webkit-box-shadow: 0px 0px 40px rgba(0,0,0,0.1); */
    box-shadow: none;
}
</style>

<script>
import notie from 'notie'
import axios from 'axios'
import router from './../router'
import store from './../store'
// import * as moment from 'moment';
export default {
  name: 'Login',
  data () {
    return {
        email: '',
        password: ''
    }
  },
  methods: {
    handleAuth () {
      console.log('handleAuth')

      axios.post(store.state.apiUrl+'crmauth', {
        email: this.email,
        password: this.password
      })
     .then(function (response) {
        // console.log(response.data);
        // status: "success"
        // token: "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1IjoibWFydGluQGhvdGVsaWVyby5hcHAiLCJpYXQiOjE1NDY4OTgwNzQsImV4cCI6MTU0Njk4NDQ3NCwiYXVkIjoiaHR0cHM6Ly9jcm0uaG90ZWxpZXJvYXBwLmNvbSIsImlzcyI6IkhvdGVsaWVybyIsInN1YiI6Im1hcnRpbkBob3RlbGllcm8uYXBwIn0.FCDiCr8mPPCEe9f_J0t_oZUgMzuAK8vl0UqcstH__19VDRQw54E3UlyhCNSqTSFHsLtEY1McLtbtfFoMv16kqQ"
        // validTill: 1546984474696
        // store to localstorage
        // window.localStorage.getItem('accessToken')
        window.localStorage.setItem('crm', JSON.stringify(response.data))
        let tmp = JSON.parse(JSON.stringify(response.data))
        store.set('u', tmp.u)  
        store.set('token', tmp.token)
        store.set('crmTokenValidTill', tmp.validTill)
        store.set('isAuthenticated', true)
        // notie.alert({type: 'success', text: 'Welcome ' + response.data.u })
        router.push({name:"leads"})
     })
     .catch(function (error) {
        console.log('err:' , error)
        notie.alert({type: 'error', text: 'Invalid email or password <br/>' + error })
     })
      // call api crmauth
      // return token
      // return valid time
      // return config object
      // return user object
    },
    login () {
      // notie.alert({type: 'error', text: 'Invalid email or password' })
      console.log('login', this.email, this.password)
      if (this.email === '' || this.password === '') {
        notie.alert({type: 'error', text: 'Invalid email or password' })
      } else {
        this.handleAuth()
      }
      /*
      axios
      .get('http://localhost:3001/api/crmevents/'+this.$route.params.id)
      .then(response => {
        console.log(response)
      })
      */
    }
  },
  mounted () {
  }
}
</script>
